import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Card, Container } from "react-bootstrap";
import { useAlert } from "../../../../context/AlertContext";
import { useLoading } from "../../../../context/LoadingContext";
import {
  addEditServiceRequest,
  getServiceRequest
} from "../../../../commons/ServiceRequest";
import SequenceStatusForm from "../../../../components/GeneralForm/SequenceStatusForm";
import SequenceStatusService from "../../../../services/sequencestatus.service";
import AgencyStatusForm from "../../../../components/GeneralForm/AgencyStatusForm";
import DepartJobsService from "../../../../services/departjob.service";

export default function EditWorkOrderStatusInformation() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const [editData, setEditData] = useState(null);
  const titleId = `แก้ไขข้อมูลสถานะใบสั่งงาน${
    state.type === "status" ? "" : "ตามหน่วยงาน"
  }`;
  const descriptionText = `Edit Work Order Status Information ${
    state.type === "status" ? "" : "By Agency"
  } Page`;

  useEffect(() => {
    if (state.type === "status") {
      getServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: SequenceStatusService.getSequenceStatuses(id),
        callback: (res) => setEditData(res)
      });
    } else {
      getServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: DepartJobsService.getDepartJobs(id),
        callback: (res) => setEditData(res)
      });
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>{titleId}</title>
        <meta name="description" content={descriptionText} />
      </Helmet>

      <Container fluid className="p-3">
        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Header className="p-3 bg-transparent border-bottom-0">
            <Card.Title className="mb-0 fs-2">{titleId}</Card.Title>
          </Card.Header>

          {state.type === "status" ? (
            <SequenceStatusForm
              editData={editData}
              onSubmitCallback={(data) =>
                addEditServiceRequest({
                  showAlert,
                  setLoading,
                  serviceRequest: SequenceStatusService.editSequenceStatuses(
                    id,
                    data
                  ),
                  navigated: (navi) => navi && navigate(0)
                })
              }
            />
          ) : (
            <AgencyStatusForm
              editData={editData}
              onSubmitCallback={(data) =>
                addEditServiceRequest({
                  showAlert,
                  setLoading,
                  serviceRequest: DepartJobsService.editDepartJobs(id, data),
                  navigated: (navi) => navi && navigate(0)
                })
              }
            />
          )}
        </Card>
      </Container>
    </>
  );
}
